import axios from 'axios';
import { SummaryWidgetCounts } from '../definitions/inventorySummary';

interface SensorSummaryResponse {
  totalSensors: number;
  totalNew: number;
  totalSold: number;
  totalInstalled: number;
  totalUsed: number;
  totalRMA: number;
  totalWrittenOff: number;
  totalTesting: number;
}

export const fetchInventorySummaryCounts = async (token: string | null): Promise<SummaryWidgetCounts> => {
  const path = `${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/summary`;
  const response = await axios.get<SensorSummaryResponse>(path, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json, text/plain, */*',
    },
  });
  const data = response.data;

  return {
    total: data.totalSensors,
    new: data.totalNew,
    sold: data.totalSold,
    installed: data.totalInstalled,
    used: data.totalUsed,
    rma: data.totalRMA,
    writtenOff: data.totalWrittenOff,
    testing: data.totalTesting,
  };
};
